import { useContext } from "react";
import { WsNotifyContext } from "common/ws/WsNotify";
import WsnTestContent from "./WsnTestContent";
import WsnConnectionMessage from "./WsnConnectionMessage";

const WsnStart = () => {
  const wsNotifyContextValue = useContext(WsNotifyContext);

  return (
    <div>
      <div>START</div>
      <div>
        wsNotifyContextValue:
        {wsNotifyContextValue.notifyTime
          ? wsNotifyContextValue.notifyTime.toLocaleString()
          : ""}
      </div>
      <WsnTestContent />
      <WsnConnectionMessage />
    </div>
  );
};

export default WsnStart;
